import { call, put, takeLatest } from 'redux-saga/effects';

import { getManagements } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getManagements);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* managementsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
